import React from 'react';
import { Box, Divider, Typography, Card, CardContent, Button } from '@mui/material';
import LoadLatestResultsButton from '@/components/LoadLatestResultsButton';
import AnalysisResultsDisplay from './AnalysisResultsDisplay';
import KeywordStorageStatus from './KeywordStorageStatus';
import { useAppContext } from '../../context/AppContext';
import { useDatabaseMode } from '../../context/DatabaseModeContext';

interface AnalysisResultsProps {
  data: any;
  workflowId: string;
  isProcessing: boolean;
  serviceAvailable: boolean;
  onReprocess: () => void;
  onResultsLoaded: (results: any) => void;
  onEditInputs?: () => void;
}

const AnalysisResults: React.FC<AnalysisResultsProps> = ({
  data,
  workflowId,
  isProcessing,
  serviceAvailable,
  onReprocess,
  onResultsLoaded,
  onEditInputs
}) => {
  const { isUsingDatabaseApproach } = useDatabaseMode();
  const keywordCount = data?.keyword_count || data?.keywords?.length;
  
  return (
    <Box>
      {/* Show keyword storage status when using database approach */}
      <KeywordStorageStatus
        isProcessing={false}
        isUsingDatabaseApproach={isUsingDatabaseApproach}
        analysisComplete={true}
        storedKeywordCount={keywordCount}
        totalKeywordCount={keywordCount}
      />
      
      <Card sx={{ mt: isUsingDatabaseApproach ? 2 : 0 }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" fontWeight="bold">Analysis Results</Typography>
            {onEditInputs && (
              <Button 
                onClick={onEditInputs}
                variant="outlined"
                size="small"
              >
                Edit Inputs
              </Button>
            )}
          </Box>
          <Divider sx={{ mb: 3 }} />
          <AnalysisResultsDisplay 
            data={data} 
            workflowId={workflowId} 
            onReprocess={onReprocess}
            isProcessing={isProcessing}
            serviceAvailable={serviceAvailable}
            onResultsLoaded={onResultsLoaded}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default AnalysisResults;
